// extracted by mini-css-extract-plugin
module.exports = {"opinionByline":"OpinionByline_opinionByline__Nj492"};